export default __webpack_public_path__ + "static/tabs-left-bunnies-4584e3c545b86f93ec182f36767089c0.svg";